import { css } from '@emotion/react';
import { Surface } from '@spotnana/blocks/src/Surface';
import { Typography } from '@spotnana/blocks/src/Typography';
import { useTranslation } from 'react-i18next';

const delayed_invoicing_option = css`
  padding: 16px 54px;
`;

const DelayedInvoicingOption = () => {
  const { t: tt } = useTranslation('WEB');

  return (
    <Surface
      variant="base"
      borderRadius="outer"
      css={delayed_invoicing_option}
      data-testid="delayed-invoice-payment-section"
    >
      <Typography as="p" color="secondary" variant="body2" kind="semibold">
        {tt("Don't worry about this.")}
      </Typography>
      <Typography as="p" color="secondary" variant="body2">
        {tt('This booking will be billed directly to your employer.')}
      </Typography>
    </Surface>
  );
};

export default DelayedInvoicingOption;
